const passthroughFundStatusLookup = [
    { id: 'Ready', value: 'Ready', name: 'Ready', label: 'Ready' },
    { id: 'Not Ready', value: 'Not Ready', name: 'Not Ready', label: 'Not Ready' }
  ];
  
  export { passthroughFundStatusLookup };
  